import type { ObjectEntryDefinition } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const objectEntryResolver =
  createSimpleNamedExpressionResolver<ObjectEntryDefinition>(
    'objectEntry',
    (k, v) => ({ [k]: v })
  );
